export class CalendarLotDay {
    scheduleCalendarLotId?: number;
    lotId: number;
    calendarDate: Date;
    isWorking: boolean;
}
